import "./App.css";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
// import Services from './components/services/Services';
// import Testimonials from './components/testimonials/Testimonials';
import Qualification from "./components/qualification/Qualification";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import ScrollUp from "./components/scrollup/ScrollUp";
import Portfolio from "./components/projects/Portfolio";

const App = () => {
  return (
    <>
      <Header />
      <main className="main">
        <Home />
        <About />
        {/* <Services /> */}
        <Qualification />
        <Portfolio />
        {/* <Testimonials /> */}
        <Skills />
        <Contact />
      </main>
      <Footer />
      <ScrollUp />
    </>
  );
};

export default App;
